import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/search.svg'
import _imports_1 from '@/assets/icons/pagefirstenabled.svg'
import _imports_2 from '@/assets/icons/pagefirstdisabled.svg'
import _imports_3 from '@/assets/icons/pagelastenabled.svg'
import _imports_4 from '@/assets/icons/pagelastdisabled.svg'
import _imports_5 from '@/assets/icons/warnerror.svg'
import _imports_6 from '@/assets/icons/mailsent.svg'


const _hoisted_1 = {
  key: 0,
  class: "modal-title",
  id: "asignusertitle"
}
const _hoisted_2 = {
  key: 1,
  class: "innerModal"
}
const _hoisted_3 = {
  key: 0,
  class: "bottommargin titlestyle"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"25px"},
  alt: "searchimg",
  title: "searchimg"
}, null, -1)
const _hoisted_5 = { class: "pagelabel" }
const _hoisted_6 = {
  key: 0,
  src: _imports_1,
  style: {"width":"20px"},
  alt: "firstpageiconimg",
  title: "firstpageiconimg"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_2,
  style: {"width":"20px"},
  alt: "firstpageiconimg",
  title: "firstpageiconimg"
}
const _hoisted_8 = {
  key: 0,
  src: _imports_3,
  style: {"width":"20px"},
  alt: "lastpageiconimg",
  title: "lastpageiconimg"
}
const _hoisted_9 = {
  key: 1,
  src: _imports_4,
  style: {"width":"20px"},
  alt: "lastpageiconimg",
  title: "lastpageiconimg"
}
const _hoisted_10 = {
  key: 3,
  class: "maxitemsdiv"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "warnimagestyle",
  alt: "warnimg",
  title: "warnimg"
}, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "errordiv",
  style: {"padding":"1rem 0"}
}
const _hoisted_13 = {
  key: 1,
  class: "errordiv",
  style: {"padding":"1rem 0"}
}
const _hoisted_14 = { class: "buttonsdiv btnbottomdiv" }
const _hoisted_15 = {
  key: 0,
  class: "fa fa-refresh fa-spin"
}
const _hoisted_16 = {
  key: 2,
  class: "innerModal"
}
const _hoisted_17 = { class: "labeldiv" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  style: {"width":"70px","margin-bottom":"1rem"},
  alt: "mailsentimg",
  title: "mailsentimg"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "labelbld" }, "Notification email sent to: ", -1)
const _hoisted_20 = { class: "labelfont" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { class: "buttonsdiv btnbottomdiv" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.taskType === 'assign' || _ctx.taskType === 'emailSent')
      ? (_openBlock(), _createElementBlock("h4", _hoisted_1, " ASSIGN USERS "))
      : _createCommentVNode("", true),
    (_ctx.taskType === 'assign' || _ctx.taskType === 'account')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.taskType === 'assign' || _ctx.taskType === 'account')
            ? (_openBlock(), _createElementBlock("label", _hoisted_3, "Select available users"))
            : _createCommentVNode("", true),
          (_ctx.taskType === 'assign' || _ctx.taskType === 'account')
            ? (_openBlock(), _createBlock(_component_el_input, {
                key: 1,
                id: "assignusersearch",
                modelValue: _ctx.userSearchValue,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userSearchValue) = $event)),
                placeholder: "Search",
                type: "search",
                debounce: "1000",
                class: "rightmargin inpstyle bottommargin"
              }, {
                suffix: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(
        !_ctx.showError
          ? 'useroverflowdiv heightnoerror'
          : 'heightwitherror useroverflowdiv'
      )
          }, [
            (_ctx.taskType === 'assign' || _ctx.taskType === 'account')
              ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                  key: 0,
                  id: "assignusertable",
                  ref: "assignusertable",
                  data: _ctx.userOptions,
                  style: {"width":"100%"},
                  "header-cell-style": _ctx.headerstyle,
                  "row-style": _ctx.rowdatastyle,
                  onSelect: _ctx.handleSelectionChange,
                  onSelectAll: _ctx.handleSelectionChange,
                  onSortChange: _ctx.handleSorting,
                  "default-sort": { prop: 'name', order: 'ascending' },
                  "empty-text": "No users available"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      type: "selection",
                      width: "55"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "User Name",
                      prop: "name",
                      sortable: ""
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Email",
                      prop: "email"
                    })
                  ]),
                  _: 1
                }, 8, ["data", "header-cell-style", "row-style", "onSelect", "onSelectAll", "onSortChange"])), [
                  [_directive_loading, _ctx.loading]
                ])
              : _createCommentVNode("", true)
          ], 2),
          (_ctx.totalPages > 1 && (_ctx.taskType === 'assign' || _ctx.taskType === 'account'))
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass(!_ctx.showError ? 'usermodalpagingdiv' : 'usermodalpagingdivwitherror')
              }, [
                _createElementVNode("label", _hoisted_5, [
                  _createElementVNode("strong", null, "Page " + _toDisplayString(_ctx.currentPage) + " / " + _toDisplayString(_ctx.totalPages), 1)
                ]),
                _createVNode(_component_el_button, {
                  plain: "",
                  class: "paginationbtn",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentPage = 1)),
                  id: "firstpage",
                  disabled: _ctx.currentPage === 1
                }, {
                  default: _withCtx(() => [
                    (_ctx.currentPage !== 1)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                      : _createCommentVNode("", true),
                    (_ctx.currentPage === 1)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_pagination, {
                  layout: "prev, next",
                  total: _ctx.totalRowsCount,
                  "page-size": 10,
                  "current-page": _ctx.currentPage,
                  "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentPage) = $event))
                }, null, 8, ["total", "current-page"]),
                _createVNode(_component_el_button, {
                  plain: "",
                  class: "paginationbtn",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.currentPage = _ctx.totalPages)),
                  id: "lastpage",
                  disabled: _ctx.currentPage === _ctx.totalPages
                }, {
                  default: _withCtx(() => [
                    (_ctx.currentPage !== _ctx.totalPages)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                      : _createCommentVNode("", true),
                    (_ctx.currentPage === _ctx.totalPages)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.showError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                (_ctx.addUserError !== '')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_12, _toDisplayString(_ctx.addUserError), 1))
                  : _createCommentVNode("", true),
                (_ctx.addUserError === '')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_13, _toDisplayString(_ctx.errormsg), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            (_ctx.taskType === 'account')
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  id: "assignusernext",
                  round: "",
                  class: "btnstyle ml-4",
                  variant: "warning",
                  onClick: _ctx.nextClickHandler,
                  disabled: !_ctx.enableControls || _ctx.selectedUsers.length === 0
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Next ")
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"]))
              : _createCommentVNode("", true),
            (_ctx.taskType === 'assign')
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  id: "assignuserinvite",
                  round: "",
                  class: "btnstyle ml-4",
                  variant: "warning",
                  onClick: _ctx.AssignUserInvite,
                  disabled: _ctx.selectedUsers.length === 0 || _ctx.showError || !_ctx.enableControls
                }, {
                  default: _withCtx(() => [
                    (!_ctx.enableControls || !_ctx.showError)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_15))
                      : _createCommentVNode("", true),
                    _createTextVNode(" Send Invite ")
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"]))
              : _createCommentVNode("", true),
            (_ctx.taskType === 'account')
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 2,
                  round: "",
                  class: "btnstyle ml-4",
                  variant: "warning",
                  id: "backbutton",
                  onClick: _ctx.backClickHandler
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Back ")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              id: "assignusercancel",
              round: "",
              variant: "outline-dark",
              onClick: _ctx.cancelInvite,
              class: "cancelbtn"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.taskType === 'emailSent')
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _hoisted_19,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifiedUsers, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                style: {"display":"flex"}
              }, [
                _createElementVNode("p", _hoisted_20, [
                  _createElementVNode("strong", null, _toDisplayString(item.name), 1),
                  _createTextVNode(" "),
                  _hoisted_21,
                  _createTextVNode(" (" + _toDisplayString(item.email) + " ) ", 1)
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_el_button, {
              id: "assignuserdone",
              round: "",
              class: "btnstyle",
              variant: "warning",
              onClick: _ctx.cancelInvite,
              style: {"float":"right"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Done ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}